//import the embeddable class
var TrackedSmsEmbeddable = require("../../embeddables/TrackedSmsEmbeddable") ;

var trackedSmsController = new TrackedSmsEmbeddable();

module.exports = trackedSmsController ;